import {
  WORKPLACE_REQUEST_WORKFLOW_ACTIONS,
  type WorkplaceRequestTypeElement,
  type WorkplaceRequestWorkflow
} from "@gettactic/api";
import { isSubmittableRequestType } from "./requestTypeKind";

/** The parts of a request type these predicates need. */
type WorkflowBearing = {
  workflows?: Pick<WorkplaceRequestWorkflow, "action" | "enabled">[];
};

/**
 * A type can gate a resource only if it can actually book one — core rejects a
 * `ticket_type_ids` entry whose type has no enabled `reservations:create`
 * workflow, because filing it would never produce a reservation.
 */
export const hasEnabledReservationWorkflow = (type: WorkflowBearing): boolean =>
  (type.workflows ?? []).some(
    (workflow) =>
      workflow.enabled &&
      workflow.action === WORKPLACE_REQUEST_WORKFLOW_ACTIONS.createReservation
  );

/** The parts of a request type {@link eligibleResourceTicketTypes} needs. */
type GatingCandidate = WorkflowBearing &
  Pick<Partial<WorkplaceRequestTypeElement>, "kind" | "schedule_requirement">;

/**
 * Types core will accept in a resource's `ticket_type_ids` **and** that the
 * booking wizard can actually file. Generic so it hands back whatever it was
 * given — callers keep the full element, not a widened one.
 */
export const eligibleResourceTicketTypes = <T extends GatingCandidate>(
  types: T[]
): T[] =>
  types.filter(
    (type) =>
      isSubmittableRequestType(type) &&
      hasEnabledReservationWorkflow(type) &&
      type.schedule_requirement !== "required"
  );
